module.exports = __webpack_public_path__ + "static/media/biquette.c79f9c0a.svg";